import { mainMenuInitialState } from "./uiLandingPageMainMenuState";

export const makeMainMenuActions = (set, get) => ({
  toggleMenu: () =>
    set((s) => ({
      mainMenu: { ...s.mainMenu, isMenuOpen: !s.mainMenu.isMenuOpen },
    })),
  toggleDelMenu: () =>
    set((s) => ({
      mainMenu: {
        ...s.mainMenu,
        isDelMenuExpanded: !s.mainMenu.isDelMenuExpanded,
      },
    })),
  toggleJsaMenu: () =>
    set((s) => ({
      mainMenu: {
        ...s.mainMenu,
        isJsaMenuExpanded: !s.mainMenu.isJsaMenuExpanded,
      },
    })),
  toggleSamplingEventsMenu: () =>
    set((s) => ({
      mainMenu: {
        ...s.mainMenu,
        isSamplingEventsMenuExpanded: !s.mainMenu.isSamplingEventsMenuExpanded,
      },
    })),
  toggleSafetyFormsMenu: () =>
    set((s) => ({
      mainMenu: {
        ...s.mainMenu,
        isSafetyFormsMenuExpanded: !s.mainMenu.isSafetyFormsMenuExpanded,
      },
    })),

  resetMainMenu: () => set({ mainMenu: mainMenuInitialState }),
});
